import { academyApiUrl } from './academyBackend';
import { parseJsonResponse } from './leadsAPI';

export async function sendPersonalAreaVerification(phone) {
  const response = await fetch(academyApiUrl('/api/academy-digital-course-users/verify-phone'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone }),
  });
  return parseJsonResponse(response);
}

export async function verifyPersonalAreaCode({ phone, code }) {
  const response = await fetch(academyApiUrl('/api/academy-digital-course-users/verify-code'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone, code }),
  });
  return parseJsonResponse(response);
}

export async function refreshPersonalAreaSession({ userId, phone }) {
  const response = await fetch(academyApiUrl('/api/academy-digital-course-users/session/refresh'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, phone }),
  });
  const result = await response.json().catch(() => ({}));
  if (response.status === 404 || response.status === 401) {
    const err = new Error(result.message || result.error || 'Session ended');
    err.code = 'PERSONAL_AREA_SESSION_ENDED';
    throw err;
  }
  if (!response.ok || result.success === false) {
    throw new Error(result.message || result.error || 'Request failed');
  }
  return result;
}

export async function registerPersonalAreaUser(payload) {
  const response = await fetch(academyApiUrl('/api/academy-digital-course-users/register'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
}
